module.exports = __webpack_public_path__ + "img/MAH-logo.d85bfcc2.svg";